// ============================================================
// libellePage — de QUEL plan parle une ligne du traitement.
// ------------------------------------------------------------
// 29 octobre 2026, devis 2026-10-046 : 34 documents déposés un par un,
// 50 lignes qui disaient toutes « Page 1 ». Chaque document est un fichier
// à part, donc chacun commence à la page 1 — le numéro seul ne désigne rien.
//
// On nomme le plan par la référence LUE quand la lecture l'a rendue, sinon
// par le nom du fichier ; le numéro de page ne vient qu'ensuite, et
// seulement si le document en a plusieurs.
// ============================================================

/** Le nom du fichier sans son extension : « 24546_B_Bloc.pdf » → « 24546_B_Bloc ». */
function sansExtension(nom) {
  return String(nom).replace(/\.(pdf|jpe?g|png|tiff?)$/i, '');
}

export function libellePage(p) {
  const nom = p.reference || (p.document ? sansExtension(p.document) : null);
  const total = p.pages_document ?? null;
  const page = total > 1 ? `page ${p.page_number}/${total}` : null;
  if (!nom) return `Page ${p.page_number ?? '?'}`;
  return page ? `${nom} — ${page}` : nom;
}
